import React from 'react';
import {
  Component,
  PuzzleButton,
} from "puzzle";
import FilterListItem from "./FilterListItem";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { FILTERS_LIST_PROPS } from "./Types";
import { Container } from "puzzle";
const SortableItem = SortableElement(({ value }: any) => <FilterListItem
  currentItem={value} />);

const SortableList = SortableContainer((props: any) => {
  const { items, context } = props;
  return (
    <ul
      className='tp-landing-page-filters-content tp-user-select-none'
      aria-label={props.ariaLabel}
    >
      {!!items.length && items.map((value: any, index: any) => (
        <SortableItem key={`item-${value.filterId}`} index={index} value={value} />
      ))}
      <Container
        className={'tp-filter-list-item-wrap pd-filter-add-new'}
        displayFlex
        htmlTag={'li'}>
        <PuzzleButton
          className="tp-filter-list-item tp-filter-list-item-new tp-text-underline"
          tabIndex={0}
          onClick={context.createFilter}
        >
          {context.translate('newFilter')}
        </PuzzleButton>
      </Container>
    </ul>
  );
});

class FiltersList extends Component<FILTERS_LIST_PROPS, {}> {
  namespacePrefix = 'Filters';

  createFilter = () => this.dispatch('openFilterDialog');

  renderBody() {
    const { filters = [] } = this.props;
    return (
      <SortableList
        ariaLabel={this.translate('SRL-filterList')}
        items={filters}
        context={this}
        onSortEnd={this.props.onSortEnd}
        axis='xy'
        distance={5}
      />
    );
  }
}

export default FiltersList;
